import { OdQueryParam } from "../enums";
import { helperFunctions } from "../helper";
import NetworkService from "../network/networkService";
import { Observable } from "rxjs";
import {
  IDemoInventoryAllResponse,
  IDemoTrialAllResponse,
  IDemoTrialProduct,
  IDemoTrialProductAllResponse,
} from "../models";
import { URLConfig } from "../network/urlStore";

export const getDemoTrial = (
  queryParams?: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<IDemoTrialAllResponse> => {
  let url = URLConfig.getDemoTrialsTrialMasterURL();
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as IDemoTrialAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching demo Inventory Data", error);
      }
    );
  });
};
export const getDemoTrialNextPage = (
  nextPageURI: string
): Observable<IDemoTrialAllResponse> => {
  let url = URLConfig.getDemoTrialNextPageTrialMasterURL(nextPageURI);


  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (demoTrialResponse) => {
        if (demoTrialResponse) {
          const demoTrialResponses =
            demoTrialResponse as unknown as IDemoTrialAllResponse;

          subscriber.next(demoTrialResponses);
        }

        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching Demo Inventory Data", error);
      }
    );
  });
};

export const getContentLengthForDemoTrial = (
  queryParams?: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<number> => {
  let url = URLConfig.getDemoTrialsTrialMasterURL();
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then((res: any) => {
        subscriber.next(res?.contentLength ?? 0);
        subscriber.complete();
      })
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log("Error while fetching Demo Trial Data:", error);
      });
  });
};

export const createDemoTrial = (requestPayload: any): Observable<any> => {
  let url = URLConfig.getDemoTrialsTrialMasterURL();
  return new Observable((subscriber) => {
    NetworkService.post(url, requestPayload).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as IDemoTrialAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while adding product in inventory", error);
      }
    );
  });
};

export const getDemoTrialDataById = (
  id: string,
  queryParams?: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<IDemoTrialProduct> => {
  let url = URLConfig.getDemoTrialDataByIdTrialMasterURL(id);
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as IDemoTrialProduct;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching demo trial data", error);
      }
    );
  });
};

export const getContentLengthForDemoTrialProducts = (
  id: any,
  queryParams?: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<number> => {
  let url = URLConfig.getDemoTrialProductsByTrialId(id);
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then((res: any) => {
        subscriber.next(res?.contentLength ?? 0);
        subscriber.complete();
      })
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log("Error while fetching Field Journal Data:", error);
      });
  });
};


export const getDemoTrialById = (
  id?: string,
  queryParams?: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<IDemoTrialProductAllResponse> => {
  let url = URLConfig.getDemoTrialProductsByTrialId(id);
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {

          const response = res as unknown as IDemoTrialProductAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching demo trial data", error);
      }
    );
  });
};

export const getDemoTrialByIdNextPage = (
  nextPageURI: string
): Observable<IDemoTrialProductAllResponse> => {
  let url = URLConfig.getDemoTrialByIdNextPageTrialMasterURL(nextPageURI);

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as IDemoTrialProductAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching demo trial next page data", error);
      }
    );
  });
};


export const getAllDemoTrialProductsById = (
  id?: string,
  queryParams?: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<IDemoTrialProduct[]> => {
  let allValues: IDemoTrialProduct[] = [];

  return new Observable((subscriber) => {
    const errorHandler = (error: any) => {
      subscriber.error(error);
    };

    const responseHandler = (response: IDemoTrialProductAllResponse) => {
      const demoProductResponse = response;
      allValues = [...allValues, ...(demoProductResponse.demoTrialProducts || [])];

      if (demoProductResponse.nextPageUri) {
        getDemoTrialByIdNextPage(demoProductResponse.nextPageUri).subscribe({
          next: responseHandler,
          error: errorHandler,
          complete: () => {
            console.info("Completed fetching all demo trial records");
          },
        });
      } else {
        subscriber.next(allValues);
        subscriber.complete();
      }
    };

    getDemoTrialById(id, queryParams).subscribe({
      next: responseHandler,
      error: errorHandler,
    });
  });
};

export const deleteDemoTrial = (id: string): Observable<any> => {
  let url = URLConfig.getDemoTrialDataByIdTrialMasterURL(id);
  return new Observable((subscriber) => {
    NetworkService.delete(url).then(
      (response) => {
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while updating demoTrial", error);
      }
    );
  });
};

export const updateDemoTrial = (
  requestPayload: any,
  id: string,
  queryParams?: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<any> => {
  let url = URLConfig.updateDemoTrialTrialMasterURL(id);
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.put(url, requestPayload).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as IDemoInventoryAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while adding product in trial", error);
      }
    );
  });
};


export const deleteDemoTrialProduct = (id: string, demoTrialProductId: string): Observable<any> => {
  let url = URLConfig.getDeleteDemoTrialProductsURL(id, demoTrialProductId);
  return new Observable((subscriber) => {
    NetworkService.delete(url).then(
      (response) => {
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while updating demoInventoryProduct", error);
      }
    );
  });
};



export const modifyDemoTrialProducts = (
  id: string,
  requestPayload?: any
): Observable<any> => {
  let url = URLConfig.getDemoTrialModifyProductURL(id);
  return new Observable((subscriber) => {
    NetworkService.patch(url, requestPayload).then(
      (res: unknown) => {
        subscriber.next(res);
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while updating the demo Inventory Products", error);
      }
    );
  });
};


export const deleteDemoTrialProducts = (
  id: string,
  requestPayload?: any,
  queryParams?: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<any> => {
  let url = URLConfig.deleteDemoTrialProductsTrialMasterURL(id);
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.patch(url, requestPayload).then(
      (res: unknown) => {
        subscriber.next(res);
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while updating the demo Inventory Products", error);
      }
    );
  });
};

export const patchDemoTrial = (
  id: string,
  requestPayload?: any
): Observable<any> => {
  let url = URLConfig.getDemoTrialDataByIdTrialMasterURL(id);
  return new Observable((subscriber) => {
    NetworkService.patch(url, requestPayload).then(
      (res: unknown) => {
        subscriber.next(res);
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while updating the demo Inventory Products", error);
      }
    );
  });
};


export const UpdateDemoTrial = (
  id: string,
  requestPayload?: any
): Observable<any> => {
  let url = URLConfig.getDemoTrialDataByIdTrialMasterURL(id);
  return new Observable((subscriber) => {
    NetworkService.put(url, requestPayload).then(
      (res: unknown) => {
        subscriber.next(res);
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while updating the demo Inventory Products", error);
      }
    );
  });
};

